export class Logger {
    /*                          */

    static group(title: string) {
        if (window.o_global.debug.status().activated) {
            if (console.group) {
                console.group(title);
            }
        }
    }

    static groupEnd() {
        if (window.o_global.debug.status().activated) {
            if (console.groupEnd) {
                console.groupEnd();
            }
        }
    }

    static log(msg: string) {
        if (window.o_global.debug.status().activated) {
            console.log(msg);
        }
    }

    static warn(msg: string) {
        if (console.warn && window.o_global.debug.status().activated) {
            console.warn(msg);
        }
    }

    static count(label: string) {
        if (window.o_global.debug.status().activated) {
            if (console.count) console.count(label);
        }
    }

}